module.exports = __webpack_public_path__ + "media/applicants/earnmoney-d1cf39a8.svg";